import qs from 'qs';
import { axiosInstance } from './rest';
import axios from 'axios';

let cardsExportCancelToken;

export function fetchCardsForExport(params) {
  cardsExportCancelToken = axios.CancelToken.source();
  const config = {
    params,
    timeout: 0,
    paramsSerializer: par => qs.stringify(par, { indices: false, encode: false }),
    cancelToken: cardsExportCancelToken.token,
  };
  return axiosInstance.get('/api/v2/standardDevices', config);
}

export function getCardsExportCancelToken() {
  return cardsExportCancelToken;
}

export function importStandardDevicesCSV(csvFile, updateIfExists, timezone) {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    timeout: 0,
  };
  const fileData = new FormData();
  fileData.append('file', csvFile);
  return axiosInstance.post(`/api/v2/standardDevices/import/csv?updateIfExists=${updateIfExists}&timeZone=${timezone}`, fileData, config);
}

export function createStandardDeviceWaitKey(deviceData) {
  return axiosInstance.post('/api/v2/standardDevices/waitKey', deviceData);
}

export function encodeStandardDevice(standardDeviceId, encoderId) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 60000,
  };
  return axiosInstance.post(`/api/v2/standardDevices/${standardDeviceId}/waitKey/${encoderId}/encode`, config);
}

export function fetchCompanyEncoders() {
  return axiosInstance.get('/api/v2/companies/encoders');
}

export function createCompanyEncoder(encoderData) {
  return axiosInstance.post('/api/v2/companies/encoders', encoderData);
}

export function deleteCompanyEncoder(encoderId) {
  return axiosInstance.delete(`/api/v2/companies/encoders/${encoderId}`);
}

export function fetchEncoderInitCode(encoderId) {
  return axiosInstance.get(`/api/v2/companies/encoders/${encoderId}/initCode`);
}

export function keyCheckForUpdate(encoderId) {
  return axiosInstance.post(`/api/v2/companies/encoders/${encoderId}/keyCheckForUpdate`);
}
